// Shared config + styles for both the React component (epg-modal.tsx) and the
// vanilla/global build (vanilla.ts). Keep sizing here so the two builds match.

export const CFG = {
  id: "epgTerms",
  width: "600px",
  maxWidth: "95vw",
  topOffset: "8vh",
  iframeHeight: "560px",
  fadeDuration: 400,
} as const;

// Payment-authorization clickwrap (auth.php) — sized to fit the CAD PAD variant
// (the tallest: 4-item certification + recourse rights paragraph).
export const AUTH_CFG = {
  id: "epgAgentAuth",
  width: "720px",
  iframeHeight: "720px",
} as const;

export type EpgSize = { id: string; width: string; iframeHeight: string };

export const GENERAL_SIZE: EpgSize = {
  id: CFG.id,
  width: CFG.width,
  iframeHeight: CFG.iframeHeight,
};

export const AUTH_SIZE: EpgSize = {
  id: AUTH_CFG.id,
  width: AUTH_CFG.width,
  iframeHeight: AUTH_CFG.iframeHeight,
};

export const modalCSS = `
.epg-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.4);
  z-index: 1050;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  opacity: 0;
  transition: opacity 0.4s ease;
}

.epg-modal-backdrop.epg-show {
  opacity: 1;
}

.epg-modal-dialog {
  margin-top: 8vh;
  transform: translateY(-12px);
  transition: transform 0.4s ease, opacity 0.4s ease;
  opacity: 0;
}

.epg-modal-dialog.epg-show {
  transform: translateY(0);
  opacity: 1;
}

.epg-modal-content {
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  overflow: hidden;
  border: 0;
  padding: 20px;
  background: white;
  box-shadow: 0 8px 32px rgba(0,0,0,0.25);
}

.epg-modal-container {
  flex: 1 1 auto;
  display: flex;
}

@media (max-width: 768px) {
  .epg-modal-dialog {
    margin-top: 6vh;
  }
  #epgTerms,
  #epgAgentAuth {
    height: 70vh;
  }
}
`;
